export const fire = require('./fire.wav');
export const wave = require('./wave.wav');
export const rain = require('./rain.wav');
export const creek = require('./creek.wav');
export const bird = require('./bird.wav');